import React from 'react';

export default function Skill(){
  return (  
    <div className="skill" id="skill">
      <div className="container">
        <div className="row">
            <div className="col-md-12">
              <h2 className="heading">Skills</h2>
            </div>
        </div>
      </div>
    </div>
  )
}